import React from "react";
import ProgressBar from "react-animated-progress-bar";

const About = () => {
  return (
    <div>
      <h2 className="font-bold text-3xl text-center text-white">About Me</h2>
      <div className="w-1/2 mx-auto my-4">
        <p className="text-red-800">
          I am very passionate about the development sector of computer science.
          I always wanted to learn new things and believe in hard work. I love
          to take challenges and work individually or in a team.
        </p>
      </div>
      <div className="w-1/2 mx-auto grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        <div className="flex flex-col items-center">
        <h4 className="text-center text-white">React</h4>
          <ProgressBar
            width="230"
            trackWidth="13"
            percentage="95"
            fontColor="white"
          />
        </div>
        <div className="flex flex-col items-center">
            <h4 className="text-center text-white">MongoDB</h4>
          <ProgressBar
            width="230"
            trackWidth="13"
            percentage="90"
            fontColor="white"
          />
        </div>
        <div className="flex flex-col items-center">
        <h4 className="text-center text-white">HTML/CSS</h4>
          <ProgressBar
            width="230"
            trackWidth="13"
            percentage="100"
            fontColor="white"
          />
        </div>
        <div className="flex flex-col items-center">
        <h4 className="text-center text-white">Javascript</h4>
          <ProgressBar
            width="230"
            trackWidth="13"
            percentage="85"
            fontColor="white"
          />
        </div>
        <div className="flex flex-col items-center">
        <h4 className="text-center text-white">Firebase</h4>
          <ProgressBar
            width="230"
            trackWidth="13"
            percentage="80"
            fontColor="white"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
